module.exports = __webpack_public_path__ + "static/img/9.18d4661.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/13/zh/9.png
// module id = mwcI
// module chunks = 0